<template>
  <div class="row">
    <div class="col-md-12 text-left">
      <modal :show.sync="ModalOrderMasivo">
        <template slot="header">
          <h5 class="modal-title sub_title" id="exampleModalLabel">Actualizar rango de ordenes masivamente</h5>
        </template>
        <div class="container">
          <div class="container-fluid">
            <div class="row">
              <div class="radio-default-acre col-12">
                <PrettyRadio name="modo" v-model="modo" :value="false">Rango de ordenes</PrettyRadio>
                <PrettyRadio name="modo" v-model="modo" :value="true">Ordenes especificas</PrettyRadio>
              </div>
            </div>
            <div class="row mt-5">
              <div class="col-4" v-show="modo === false">
                <label>Orden Inicial</label>
                <base-input type="number" :min="0" v-model="num1">
                </base-input>
              </div>
              <div class="col-4" v-show="modo === false">
                <label>Orden Final</label>
                <base-input type="number" :min="num1" v-model="num2">
                </base-input>
              </div>
              <div class="col-4" v-show="modo === true">
                <label>Ordenes</label>
                <draggable class="list-group drag" :list="orders" group="order">
                  <div class=" list-group-item" v-for="(element,index) in orders" :key="index">
                    {{ 'Orden # ' + element.order_id + ', Estado: ' + element.OrderStatus.status }}
                  </div>
                </draggable>
              </div>
              <div class="col-4" v-show="modo === true">
                <label>Arrastrar ordenes para actualizar</label>
                <draggable class="list-group drag" :list="ordersupdate" group="order">
                  <div class=" list-group-item" v-for="(element,index) in ordersupdate" :key="index">
                    {{ 'Orden # ' + element.order_id + ', Estado: ' + element.OrderStatus.status }}
                  </div>
                </draggable>
              </div>
              <div class="col-4">
                <label class="typo__label">Estado</label>
                <multiselect
                    v-model="status"
                    track-by="order_status_id"
                    label="status"
                    placeholder="Seleccione un estado"
                    :options="orderstatus"
                    :searchable="true"
                >
                </multiselect>
              </div>
              <div class="col-12 mt-3 text-center">
                <base-button class="btn_submit" @click="update">Guardar</base-button>
                <base-alert type="danger" v-if="error">
                  <strong>{{ error }}</strong>
                </base-alert>
              </div>
            </div>

          </div>

        </div>
        <template slot="footer">
        </template>
        <div class="row">
          <div class="col-12">
            <base-progress v-show="progress > 0" type="success" :height="8" :value="progress"
                           label="Guardando"></base-progress>
          </div>
        </div>
      </modal>
    </div>
  </div>
</template>


<script>
import {bus} from "@/components/Order/bus-order";
import {order_service} from "@/services/order/OrderService";
import swal from "sweetalert";
import PrettyRadio from 'pretty-checkbox-vue/radio';
import draggable from 'vuedraggable'

export default {
  name: "ModalOrderUpdate",
  components: {PrettyRadio, draggable},
  data() {
    return {
      user_session: [],
      error: '',
      ModalOrderMasivo: false,
      progress: 0,
      orderstatus: [],
      status: [],
      num1: 0,
      num2: 0,
      orders: [],
      ordersupdate: [],
      modo: false
    }
  },
  methods: {
    update() {
      if (this.modo === false) {
        if (Number(this.status.order_status_id) > 0 && Number(this.num1) <= Number(this.num2)) {
          this.progress = 50
          this.error = ''
          let data = {
            state: Number(this.status.order_status_id),
            r1: Number(this.num1),
            r2: Number(this.num2),
            user_id: this.user_session.user_id
          }
          order_service.OrderStatusMAsivo(data)
          //console.log(data)
        } else {
          this.error = 'Seleccionar estado y ingresar la orden inicial y final para la actualización'
        }
      } else if (this.modo === true) {
        if (this.status.order_status_id > 0 && this.ordersupdate.length > 0) {
          this.progress = 50
          this.error = ''
          let data = []
          for (const prop in this.ordersupdate) {
            data.push({
              'OrderStatus': {'order_status_id': this.status.order_status_id},
              'order_id': Number(this.ordersupdate[prop].order_id),
              'user_id': this.user_session.user_id
            })
          }
          data.user_id = this.user_session.user_id
          order_service.UpdateOrderStatus(data)
        } else {
          this.error = 'Seleccionar estado y arrarstrar una orden para actualziar'
        }
      }

    },
    cleandatafull() {
      this.num1 = 0
      this.num2 = 0
      this.status = []
      this.progress = 0
      this.ordersupdate = []
      this.ModalOrderMasivo = false
      order_service.GetAllOrder()
    }
  },
  created() {
    this.user_session = JSON.parse(sessionStorage.getItem('user'))
    order_service.GetAllOrderStatus()
    order_service.GetAllOrderUpdate()
    bus.$on('ShowUpdateMasivo', () => {
      this.ModalOrderMasivo = true
    })
    bus.$on('GetAllOrderUpdate', (response) => {
      this.orders = response
    })
    bus.$on('GetAllOrderStatus', (response) => {
      this.orderstatus = response
    })
    bus.$on('OrderStatusMAsivo', (response) => {
      if (response.statusText === 'Created') {
        this.progress = 100
        this.cleandatafull()
        swal({
          icon: "success",
          text: "Se Ha Actualizado El Rango De Ordenes Seleccionadas",
          button: "Aceptar"
        })
      } else {
        this.progress = 100
        this.cleandatafull()
        swal({
          dangerMode: true,
          icon: "error",
          text: "No Fue Posible Actualizar Las Ordenes. Intenta Nuevamente",
          button: "Aceptar"
        })
      }
    })
    bus.$on('ResponseUpdateOrderStatus', (response) => {
      if (response.status === 200) {
        this.progress = 100
        this.cleandatafull()
        swal({
          icon: "success",
          text: "Se Ha Realizado Correctamente La Actualización",
          button: "Aceptar"
        })
      } else {
        this.progress = 100
        this.cleandatafull()
        swal({
          dangerMode: true,
          icon: "error",
          text: "No Fue Posible Actualizar Las Ordenes. Intenta Nuevamente",
          button: "Aceptar"
        })
      }
    })
  }
}
</script>

<style scoped>
.drag {
  border: 1px solid;
  padding: 0px;
  border-radius: 6px;
  height: 300px;
  overflow: auto;
}
</style>
